export default "__VITE_ASSET__Bdhs$VPq__"